export default "__VITE_ASSET__CL37ha3Q__"